import { render } from "./KobiPolygon.vue?vue&type=template&id=b19bb468"
import script from "./KobiPolygon.vue?vue&type=script&lang=js"
export * from "./KobiPolygon.vue?vue&type=script&lang=js"

import "./KobiPolygon.vue?vue&type=style&index=0&id=b19bb468&lang=css"
script.render = render

export default script